import {
  collection,
  getDocs,
  query,
  serverTimestamp,
  where,
  writeBatch
} from 'firebase/firestore';
import { db } from '../firebase';
import { isPendingOutboxItem } from './outboxCounts';

export async function requestClientOutboxCancellation({
  uid,
  clientId,
  cancellationReason = 'client_deleted'
}) {
  if (!uid || !clientId) return 0;

  const outboxRef = collection(db, 'users', uid, 'outbox');
  const outboxQuery = query(outboxRef, where('clientId', '==', clientId));
  const outboxSnapshot = await getDocs(outboxQuery);

  if (outboxSnapshot.empty) return 0;

  const batch = writeBatch(db);
  let updatedCount = 0;
  outboxSnapshot.forEach(docSnap => {
    if (!isPendingOutboxItem({ clientId, ...(docSnap.data() || {}) })) return;

    batch.update(docSnap.ref, {
      status: 'cancel_requested',
      cancelRequested: true,
      cancellationReason,
      cancelRequestedAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    updatedCount += 1;
  });

  if (updatedCount === 0) return 0;
  await batch.commit();
  return updatedCount;
}
